import { render, staticRenderFns } from "./RealEstateAgency.vue?vue&type=template&id=a84c4f7a&"
import script from "./RealEstateAgency.vue?vue&type=script&lang=js&"
export * from "./RealEstateAgency.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAgency.vue?vue&type=style&index=0&id=a84c4f7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports